/**
 * SAM.gov stores an opportunity's agency as a dotted hierarchy path —
 * "DEPT OF DEFENSE.DEPT OF THE ARMY.AMC.ACC.ACC-CTRS" — and the API returns
 * it verbatim. People read the department and, when there is one, the
 * sub-agency; the office chain below that is noise in a list.
 */
export function formatAgency(path?: string | null, options: { levels?: 1 | 2 } = {}): string {
  if (!path) return '';
  const parts = path.split('.').map((p) => p.trim()).filter(Boolean);
  if (parts.length === 0) return path;
  const department = parts[0];
  // SAM repeats the department as its own sub-tier for single-tier agencies.
  const sub = parts[1] && parts[1] !== department ? parts[1] : null;
  if ((options.levels ?? 2) === 1 || !sub) return department;
  return `${department} · ${sub}`;
}
